import React from "react";
import { APP_EMBLEMS } from "./appEmblems";

// Which app each page belongs to. Pages not listed (Home, Settings, Agent activity,
// patient chart, etc.) get no chip.
export const PAGE_APP = {
  telemedicine: "echo",
  "encounter-review": "lumina",
  dictation: "lumina",
  "chart-documents": "lumina",
  "clinic-documents": "lumina",
  "claims-queue": "revq",
  "payment-posting": "revq",
};

const APPS = {
  echo: { name: "Echo", area: "Scheduling" },
  lumina: { name: "Lumina", area: "Clinical" },
  revq: { name: "revQ", area: "Billing" },
};

const chip = {
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  height: 22,
  padding: "0 8px 0 6px",
  borderRadius: 6,
  border: "1px solid #E9E9EC",
  background: "#FFFFFF",
  color: "#6C6C69",
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1,
  whiteSpace: "nowrap",
  userSelect: "none",
  cursor: "default",
  flex: "none",
  transform: "translateY(1px)",
};

const tip = {
  position: "absolute",
  left: 0,
  top: "calc(100% + 6px)",
  background: "#141412",
  color: "#F4F4F1",
  fontSize: 11.5,
  fontWeight: 400,
  padding: "6px 8px",
  borderRadius: 6,
  whiteSpace: "nowrap",
  pointerEvents: "none",
  zIndex: 50,
  transition: "opacity .12s cubic-bezier(.4,0,.2,1), transform .12s cubic-bezier(.4,0,.2,1)",
};

export default function AppChip({ app }) {
  const [show, setShow] = React.useState(false);
  const a = APPS[app];
  if (!a) return null;
  return (
    <span
      style={chip}
      tabIndex={0}
      aria-label={`Part of ${a.name}`}
      data-testid={`app-chip-${app}`}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
    >
      <img src={APP_EMBLEMS[app]} alt="" width={12} height={12} style={{ display: "block", width: 12, height: 12 }} />
      {a.name}
      <span
        role="tooltip"
        style={{ ...tip, opacity: show ? 1 : 0, transform: show ? "none" : "translateY(-2px)" }}
      >
        Part of {a.name} · {a.area}
      </span>
    </span>
  );
}
